import {
  Content,
  ContentHeader,
  CreateButton,
  Header,
  Page,
  SupportButton,
} from '@backstage/core-components';
import { CatalogTable } from '@backstage/plugin-catalog';
import {
  CatalogFilterLayout,
  EntityListProvider,
} from '@backstage/plugin-catalog-react';
import { catalogEntityCreatePermission } from '@backstage/plugin-catalog-common/alpha';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { imageCatalogColumns } from './imageCatalogColumns';
import { ImagesCatalogFilters } from './ImagesCatalogFilters';

export const ImagesCatalogPage = () => (
  <EntityListProvider>
    <Page themeId="home">
      <Header
        title="Portal Images"
        subtitle="Shared GCP workshop image builds. Use Launch on a ready image to open the VM wizard with that build pre-selected."
      />
      <Content>
        <ContentHeader title="Image builds">
          <RequirePermission permission={catalogEntityCreatePermission}>
            <CreateButton
              title="Build image"
              to="/create/templates/default/gcp-image-build"
            />
          </RequirePermission>
          <SupportButton>
            All signed-in users can browse image builds from the Image Build
            template. Running VMs (image launches) with TTL stay on Home and are
            visible only to the person who created them.
          </SupportButton>
        </ContentHeader>
        <CatalogFilterLayout>
          <CatalogFilterLayout.Filters>
            <ImagesCatalogFilters />
          </CatalogFilterLayout.Filters>
          <CatalogFilterLayout.Content>
            <CatalogTable columns={imageCatalogColumns} />
          </CatalogFilterLayout.Content>
        </CatalogFilterLayout>
      </Content>
    </Page>
  </EntityListProvider>
);
